import createClient from '../../apolloClient';
import MUTATION_DELETE_USER from '../../mutation/deleteUser';

const handleDeleteUser = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_DELETE_USER,
    variables,
  });
  const { deleteUser } = result?.data || {};
  return deleteUser;
};

export default handleDeleteUser;
